import { render, staticRenderFns } from "./GoodsLsxiaofei.vue?vue&type=template&id=d2bfd3ce&"
import script from "./GoodsLsxiaofei.vue?vue&type=script&lang=js&"
export * from "./GoodsLsxiaofei.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports